import type { Slide, SlideInput } from '../../../types'

export const toSlidePayload = (slideForm: SlideInput): SlideInput => ({
  title: slideForm.title.trim(),
  description: slideForm.description.trim(),
  ctaLabel: slideForm.ctaLabel.trim(),
  ctaHref: slideForm.ctaHref.trim(),
  image: slideForm.image.trim(),
})

export const toSlideForm = (slide: Slide): SlideInput => ({
  title: slide.title,
  description: slide.description,
  ctaLabel: slide.ctaLabel ?? '',
  ctaHref: slide.ctaHref ?? '',
  image: slide.image ?? '',
})

export const reorderSlides = ({
  slides,
  fromId,
  targetId,
}: {
  slides: Slide[]
  fromId: string
  targetId: string
}): Slide[] | null => {
  if (fromId === targetId) return null
  const updated = [...slides]
  const from = updated.findIndex((slide) => slide.id === fromId)
  const to = updated.findIndex((slide) => slide.id === targetId)
  if (from === -1 || to === -1) return null
  const [moving] = updated.splice(from, 1)
  updated.splice(to, 0, moving)
  return updated
}
